import { differenceInYears } from 'date-fns';

import { statesWithNonStandardPIPWLValues } from '@ourbranch/lookups';

export const yesNoOptions = [
  {
    value: 'yes',
    label: 'Yes'
  },
  {
    value: 'no',
    label: 'No'
  }
];

export const yesNoIDontKnowOptions = [
  ...yesNoOptions,
  {
    value: 'idk',
    label: "I don't know"
  }
];

export const excludeEveryoneOptions = [
  {
    value: 'yes',
    label: 'Yes, exclude all'
  },
  {
    value: 'no',
    label: 'No, include all'
  }
];

export const getFormikId = (person, values) => {
  const isDriver = values.drivers.some((driver) => driver.id === person?.id);
  const index = isDriver
    ? values.drivers.findIndex((driver) => driver.id === person.id)
    : values.nonDrivers.findIndex((resident) => resident.id === person.id);

  return `${isDriver ? 'drivers' : 'nonDrivers'}[${index}]`;
};

export const getPersonAge = (dateOfBirth) => differenceInYears(new Date(), new Date(dateOfBirth));

export const michiganPipInitialValuesHelper = (state, node, value, context = []) => {
  if (state !== 'MI') {
    return value;
  }

  switch (node) {
    case 'policyLimitPIPWL':
      // if set as selected with wage-loss waived, of if anyone waived, set this to true, since its a policy level coverage and not based on individual residents
      return value === 'S/WLW' || context?.some((p) => p?.waivedPIPWL);
    case 'policyLimitPIPACR':
      // if 10k, set true, otherwise its false for no coverage,
      return value === '100000';
    case 'policyLimitPIPME':
      // 250k W Excluded did not used to exist, so if we have 250k AND opted out residents with QHC, we need to set it to 250k w/ excluded for backwards compatibility
      if (value === '250000') {
        return context?.some((p) => p?.pipHasQHC && p?.pipOptOut) ? '250000W/EXCLUDED' : '250000';
      }
      return value;
    default:
      return value;
  }
};

export const getPolicyLimitPIPWLInitialValue = (state, value, drivers = []) => {
  if (state === 'MI') {
    return michiganPipInitialValuesHelper('MI', 'policyLimitPIPWL', value);
  }

  return statesWithNonStandardPIPWLValues.includes(state)
    ? value
    : drivers?.some((d) => d?.waivedPIPWL)
      ? 'S/WLW'
      : 'S';
};

export const michiganPipISubmitValuesHelper = (state, node, value, context = []) => {
  if (state !== 'MI') {
    return value;
  }

  switch (node) {
    case 'policyLimitPIPWL':
      // if set as selected with wage-loss waived, of if anyone waived, set this to true, since its a policy level coverage and not based on individual residents
      return value || context?.some((p) => p?.waivedPIPWL) ? 'S/WLW' : 'S';
    case 'policyLimitPIPACR':
      return value ? '100000' : 'NONE';
    default:
      return value;
  }
};

export const getPolicyLimitPIPWLSubmitValue = (state, value, drivers = [], residents = []) => {
  if (state === 'MI') {
    return michiganPipISubmitValuesHelper('MI', 'policyLimitPIPWL', value, residents);
  }

  return statesWithNonStandardPIPWLValues.includes(state)
    ? value
    : drivers?.some((d) => d?.waivedPIPWL)
      ? 'S/WLW'
      : 'S';
};
